module.exports = "/images/Frame 509.jpg";